export default __webpack_public_path__ + "static/media/jeff_tang.cd06747c.png";